import { DEVICE_TYPE } from '@/constants/pageSettings'
import { isMobileDevice } from '@/utils/userAgent'

export const getClientType = (userAgent: string): string => {
  if (isMobileDevice(userAgent)) return DEVICE_TYPE.MOBILE.toLowerCase()

  return DEVICE_TYPE.DESKTOP.toLowerCase()
}
